import Vue from "modules/vue_twemoji";
import VueI18n from "vue-i18n";
import ChartSqlEditor from "components/chart/sql-editor";
import { store } from "store";

Vue.use(VueI18n);

(function() {
  if(document.querySelectorAll(".tab-body").length === 0) {
    return;
  }

  const focusAndMoveCursorToTheEnd = () => {
    if(!window.state.editor) {
      return
    }

    const editor = window.state.editor;

    editor.focus();

    const cursorPosition = editor.getCursorPosition();
    if(cursorPosition.row === 0 && cursorPosition.column === 0) {
      const n = editor.getSession().getValue().split("\n").length;
      editor.gotoLine(n);
      editor.navigateLineEnd();
    }
  };

  document.addEventListener("click", (e) => {
    if(e.target && e.target.matches(".tabs-menu__button")) {
      e.preventDefault();
      e.stopPropagation();

      const $menuItem = e.target;
      const $menu = $menuItem.closest(".tabs-menu");
      const tabId = $menuItem.dataset.tab;

      const $tab = document.querySelector(`.tab-body[data-tab='${tabId}']`);

      if($tab.dataset.tab === "chart") {
        const $container = document.querySelector(".chart-editor-container");

        const $el = document.createElement("div");
        $el.className = "js-chart-editor";

        $container.appendChild($el);
        $container.classList.add("chart-editor-container--active");

        const query = window.state.query || {};

        if(window.state.chart) {
          window.state.chart.datasetId = query.datasetId;
          window.state.chart.query = query.body;
        } else {
          window.state.chart = new Vue({
            store,
            i18n: new VueI18n({
              locale: "en"
            }),
            el: $el,
            components: {
              ChartSqlEditor
            },
            data() {
              return {
                query: query.body,
                datasetId: query.datasetId,
                closeLinkCopy: `Back to ${window.state.contentItem.contentType.toLowerCase()}`
              }
            },
            template: `
              <ChartSqlEditor
                :showRandomQueryLink="false"
                :closeLinkCopy="closeLinkCopy"
                :inputQuery="query"
                :inputDatasetId="datasetId"
                @back="closeChartEditor" />
            `,
            methods: {
              closeChartEditor() {
                const $body = document.querySelector("body");
                $body.classList.remove("no-scroll");

                $container.classList.remove("chart-editor-container--active");
              }
            },
            mounted() {
              const $body = document.querySelector("body");
              $body.classList.add("no-scroll");
            }
          });
        }
      } else {
        const $activeTab = document.querySelector(".tab-body--active");

        $activeTab.classList.toggle("tab-body--active");
        $tab.classList.toggle("tab-body--active");

        const $activeMenuItem = $menu.querySelector(".tabs-menu__button--active");

        $menuItem.classList.toggle("tabs-menu__button--active");
        $activeMenuItem.classList.toggle("tabs-menu__button--active");

        $menuItem.classList.remove("tabs-menu__button--highlight");
        $activeMenuItem.classList.remove("tabs-menu__button--highlight");

        // Scroll back from where "Run query" link was clicked
        if($menuItem.dataset.tab === "lesson" || $menuItem.dataset.tab === "exercise") {
          if(window.scrollTo && window.state && window.state.runQueryScrollY) {
            window.scrollTo(0, window.state.runQueryScrollY);
          }
        }

        // Focus on SQL Editor when this tab is opened
        if($menu.querySelector(".tabs-menu__button--active").dataset.tab === "sql_editor") {
          focusAndMoveCursorToTheEnd();
        }
      }
    }
  });
})();
